export enum MeetingPlannerMode {
  BASIC,
  ACTIVITY_TYPE_PICKER,
  ACTIVITY_START_DATE_PICKER
}
